import axios from "axios";
import actions from "./actions";
import { getFilterUrlPart, getBenchmarksParam } from "../../lib/utils";
import _ from "lodash";

const fetchQuestions = (id, options) => (dispatch, getState) => {
  const {
    units,
    token,
    survey,
    actualSurvey,
    optimized,
    comparativeDatasets,
    comparativeUnitMappings,
    comparativePositionMappings,
    surveyQuestions,
    workSettingBenchmarks,
    datasetBenchmarks,
    defaultBenchmark,
  } = options;
  const isPulse = survey.indexOf("Pulse") > -1;
  const requestBody = { comparativeDatasets, comparativeUnitMappings, comparativePositionMappings };
  const unitsParam = units
    ? `&units='${_.map(units, function(unit) {
      return encodeURIComponent(unit); //unit.replace(/&/g, "%26");
    }).join(`','`)}'`
    : "";
  dispatch(actions.fetchQuestionsStart(unitsParam));

  const benchmarksParam = getBenchmarksParam(defaultBenchmark, units, workSettingBenchmarks, datasetBenchmarks);

  const filterParams = getFilterUrlPart(getState().filters);

  function retryOnFail(task, attempt) {
    if (!attempt) {
      attempt = 1;
    }
    return task().catch(err => {
      if (attempt < 3) {
        attempt += 1;
        return retryOnFail(task, attempt);
      } else {
        dispatch(actions.fetchQuestionsError({ err, unitsParam }));
      }
    });
  }
  function getQuestion(url, column) {
    return retryOnFail(function() {
      return axios.post(url, requestBody).then(res => {
        dispatch(actions.progress({ progress: 100 / surveyQuestions.length, unitsParam }));
        return Promise.resolve({
          column,
          data: res.data,
        });
      });
    });
  }
  function getBatch(start) {
    const batchSize = isPulse && unitsParam ? 3 : 5;
    const promises = [];
    for (let i = start; i < surveyQuestions.length && i < batchSize + start; i++) {
      const domain = surveyQuestions[i].domain === "magnet_resources" ? "wk" : surveyQuestions[i].domain;
      promises.push(
        getQuestion(
          `/api/survey/${id}/bar/domain/${domain}/question/${
            surveyQuestions[i].column
          }/by/facility/sort/group_percent/desc?showAllColors=true&token=${token}&version=${actualSurvey}&abbreviated=true&optimized=${optimized}${unitsParam}&benchmarks=${benchmarksParam}${filterParams}`,
          surveyQuestions[i].column
        )
      );
      if (isPulse) {
        promises.push(
          getQuestion(
            `/api/survey/${id}/bar/domain/${domain}/question/${
              surveyQuestions[i].column
            }/by/facility/sort/group_percent/desc?showAllColors=true&token=${token}&version=${actualSurvey}&abbreviated=true&optimized=${optimized}&benchmarks=${benchmarksParam}`,
            `${surveyQuestions[i].column}-facility`
          )
        );
      }
    }
    Promise.all(promises).then(results => {
      //for (let i = 0; i < results.length; i++) {
      for (let result of results.filter(r => r)) {
        questions[result.column] = result.data;
      }
      if (start >= surveyQuestions.length) {
        dispatch(actions.fetchQuestions({ questions, unitsParam }));
      } else {
        getBatch(start + batchSize);
      }
    });
  }
  const questions = {};
  getBatch(0);
};

const clear = () => (dispatch, getState) => {
  dispatch(actions.clear());
};

export default {
  fetchQuestions,
  clear,
};



// WEBPACK FOOTER //
// ./src/redux/questions/operations.js